// Angular stuff
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfig } from './app.config';
import { SessionService } from './common/session.service';

@Injectable()
export class EnvironmentGuard implements CanActivate {

  constructor(private configService: AppConfig ,private session: SessionService) { }
  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
      return this.configService.waitUntil().then(() => {
        if (this.configService.environmentName == 'aws'){
          return true;
        }
        else{
          this.session.showMainPage();
          return false;
        }
      });
  }
}